import type { ReactNode } from "react";
import styles from "./Section.module.css";

type SectionBackground = "white" | "cream" | "emerald-dark" | "ink";
type SectionPadding = "sm" | "md" | "lg";

interface SectionProps {
  readonly background?: SectionBackground;
  readonly padding?: SectionPadding;
  readonly children: ReactNode;
  readonly className?: string;
  readonly id?: string;
}

export function Section({
  background = "white",
  padding = "lg",
  children,
  className,
  id,
}: SectionProps) {
  return (
    <section
      id={id}
      className={`${styles.section} ${styles[background]} ${styles[`pad-${padding}`]} ${className ?? ""}`}
    >
      {children}
    </section>
  );
}
